import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ProductCategoryType } from 'types';
import { Button, NeedHelp } from 'components/shared';
import { media } from 'styles';
import { sp, colors, boxShadow } from 'styles/theme';

const NeedHelpWrapper = styled.div`
  display: none;
  ${media.desktop`
    display: block;
  `};
`;

const StyledSidebar = styled.div`
  margin-right: 80px;
  width: 100%;

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: ${sp.m};
  }

  ${media.desktop`
    width: 240px;
  `};
`;

const Section = styled.div`
  margin-bottom: ${sp.xl};
`;

const CategoryToggle = styled(Button)`
  margin-bottom: ${sp.s};
  font-size: 14px;
  width: 100%;
  ${props => props.white && `color: ${colors.royal}`};
`;

const Search = styled.input`
  width: 100%;
  border: none;
  box-shadow: ${boxShadow.small};
  padding: 20px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'sofia-pro', 'Helvetica Neue', Helvetica, sans-serif;
  ::placeholder {
    color: ${colors.royal};
  }
`;

const propTypes = {
  productCategories: PropTypes.arrayOf(ProductCategoryType).isRequired,
  selectedCategoryId: PropTypes.string,
  selectCategory: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  updateSearch: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedCategoryId: undefined,
  searchTerm: undefined,
};

function Sidebar({
  productCategories,
  selectedCategoryId,
  selectCategory,
  searchTerm,
  updateSearch,
}) {
  return (
    <StyledSidebar>
      <Section>
        <Search
          type="text"
          value={searchTerm}
          onChange={updateSearch}
          placeholder="Search"
        />
      </Section>
      <Section>
        <h3>Categories</h3>
        <CategoryToggle
          block
          white={!!selectedCategoryId}
          royal={!selectedCategoryId}
          onClick={() => selectCategory(null)}
        >
          View All Services
        </CategoryToggle>

        {productCategories.map(pc => (
          <CategoryToggle
            block
            white={pc.id !== selectedCategoryId}
            royal={pc.id === selectedCategoryId}
            onClick={() => selectCategory(pc.slug)}
            key={pc.id}
          >
            {pc.name}
          </CategoryToggle>
        ))}
      </Section>
      <Section>
        <NeedHelpWrapper>
          <NeedHelp />
        </NeedHelpWrapper>
      </Section>
    </StyledSidebar>
  );
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/ProductsPage/components/Sidebar/Sidebar.jsx